export const selectedCustomDonationOptions = (customDonationInput) => {
  return [...customDonationInput.options].filter((x) => x.selected)
}

export const selectedCauses = (containerElement) => {
  const checkedCauseInputs = containerElement.querySelectorAll('input.checkbox-cause:checked')

  return [...checkedCauseInputs]
}

export const formatDropdown = (obj) => {
  // Handle Searching... placeholder or user-input tag
  if (obj.loading || obj.newTag) {
    return obj.text
    // Format group headers
  } else if (obj.children) {
    return `${obj.text} (${obj.children.length}) ${generateFlag(obj.countryCode)}`
  } else {
    return generateFormattedOptionText(obj.charity, formattedCharityNumber(obj))
  }
}

export const formatUsOnlyDropdown = (obj) => {
  // Handle Searching... placeholder
  if (obj.loading) {
    return obj.text
  } else {
    let charity = obj.charity

    const charity_number = charity.ein ? `EIN: ${charity.ein}` : false

    let formattedOptionText = generateFormattedOptionText(charity, charity_number)

    return formattedOptionText
  }
}

export const generateFlag = (countryCode) => {
  // Flag emojis are the combination of Unicode characters for each letter of a two-digit country code
  // This splits the letters to get the codes and then joins them
  return countryCode
    .split('')
    .map((letter) => {
      return String.fromCodePoint(letter.toLowerCase().charCodeAt() + 127365)
    })
    .join('')
}

export const formatSelection = (obj) => {
  // This is hacky and can probably be refactored, but
  // storing country code under "title" because that
  // key persists when chips pass back through formatting
  return `${obj.text} ${generateFlag(obj.title)}`
}

export const formatOPDSelection = (obj) => {
  if (!isNaN(obj.id) && obj.text != 'Search by charity names' && obj.charity) {
    // filter(Boolean) removes any elements in the array that are falsey
    return [obj.text, formattedCharityNumber(obj)].filter(Boolean).join(' - ')
  } else {
    return `${obj.text}`
  }
}

// Handling Charity Search Inputs
// If no countries are selected, rather than disable the charity search
// (which prevents a user from removing already-selected charities),
// we'll give a search length of Infinity so a search is never initiated
// and the dropdown message to select a country remains. Otherwise,
// searches including "US" require three characters, and all other searches
// require no typeahead.
export const inputLength = (countries) => {
  if (!countries.length) {
    return Infinity
  } else if (countries.some((el) => el.id === 'US')) {
    return 3
  } else {
    return 0
  }
}

function generateFormattedOptionText(charity, charity_number) {
  // Create an array with unique values from charity city and state, then filter out
  // any null values and separate multiple values with a comma
  const location = [...new Set([charity.city, charity.state])].filter(Boolean).join(', ')
  return [charity.name, location, charity_number].filter(Boolean).join(' - ')
}

function formattedCharityNumber(obj) {
  let charity = obj.charity
  // Since some GG charities are returned without an ein or registered_charity_number,
  // check for valid values and exclude 'charity no.' if none present
  return charity.ein || charity.registered_charity_number
    ? `charity no. ${charity.ein || charity.registered_charity_number}`
    : false
}
